<template>
  <div>
    <van-popup v-model:show="state.show" position="right" :safe-area-inset-top="true" closeable
      close-icon-position="top-left" :style="{ width: '90%', height: '100%' }">
      <div class="conversationpopup-box">
        <h3 class="title">聊天信息</h3>
        <div class="user-list">
          <div v-for="(item, i) in state.subscribers.slice(0, 10)" :key="i + 'subscribers'" class="item">
            <van-image :src="item.avatar" round class="user-avatar" />
            <p class="van-ellipsis">{{ item.remark || item.nickname || '匿名' }}</p>
          </div>
          <div class="more" @click="onMore">查看更多</div>
        </div>
        <div class="gn-box">
          <div v-if="state.channelType == 2" class="gn-item" @click="openQname">
            <div class="l">群聊名称</div>
            <div class="r">
              <p>{{ state.channelInfo.title }}</p>
            </div>
          </div>
          <!-- <div v-if="state.channelType==2" class="gn-item" @click="openQtx">
            <div class="l">群头像</div>
            <div class="r">
              <img v-if="state.channelInfo" :src="state.imapi+'/api/v1/'+state.channelInfo?.logo+'?v='+Date.now()" />
            </div>
          </div> -->
          <div v-if="state.channelType == 2" class="gn-item gg" @click="openGg">
            <div class="l">群公告</div>
            <div class="r">
              <p>{{ state.channelInfo?.orgData?.notice }}</p>
            </div>
          </div>
        </div>
        <div class="gn-box">
          <div v-if="state.channelType == 2" class="gn-item">
            <div class="l">我在本群的昵称</div>
            <div class="r">
              <p>{{ state.subscriberOfMe?.remark || state.subscriberOfMe?.nickname || '' }}</p>
            </div>
          </div>
        </div>
        <div class="gn-box">
          <div class="gn-item">
            <div class="l">消息免打扰</div>
            <div class="r">
              <van-switch v-model="state.checkedMdr" size="16px" active-color="#12CDB0" @change="onChangeMdr" />
            </div>
          </div>
          <div class="gn-item">
            <div class="l">聊天置顶</div>
            <div class="r">
              <van-switch v-model="state.checkedZd" size="16px" active-color="#12CDB0" @change="onChangeZd" />
            </div>
          </div>
        </div>
        <div v-if="state.channelType == 2" class="gn-box">
          <div class="gn-item out" @click="onClear">
            清空聊天记录
          </div>
          <div class="gn-item out" @click="onOut">
            删除并退出
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model:show="state.moreshow" position="right" :safe-area-inset-top="true" closeable
      close-icon-position="top-left" :style="{ width: '90%', height: '100%' }">
      <div class="conversationpopup-box">
        <h3 class="title">成员列表</h3>

        <van-list :finished="true" finished-text="没有更多了" style="margin-top: 10px;">
          <van-cell v-for="(item, index) in state.subscribers" :key="item + item.id">
            <div class="user-box">
              <van-image :src="item.avatar" round class="user-avatar" />
              <p class="van-ellipsis">{{ item.remark || item.nickname || '匿名' }}</p>
            </div>
          </van-cell>
        </van-list>
      </div>
    </van-popup>

    <van-popup v-model:show="state.ggshow" round>
      <div class="qgg-box">
        <h3>群公告</h3>
        <div class="qgg-sr">
          <van-field v-model="state.message" rows="2" autosize type="textarea" maxlength="400" placeholder="请输入群公告"
            show-word-limit />
        </div>
        <div class="btn" @click="onGg">
          完成
        </div>
      </div>
    </van-popup>
    <van-popup v-model:show="state.qnameshow" round>
      <div class="qgg-box">
        <h3>群名称</h3>
        <div class="qgg-sr">
          <van-field v-model="state.channelname" rows="2" autosize type="textarea" maxlength="20" placeholder="请输入群名称"
            show-word-limit />
        </div>
        <div class="btn" @click="onQname">
          完成
        </div>
      </div>
    </van-popup>
    <van-popup v-model:show="state.qtxshow" round>
      <div class="qgg-box qtx-box">
        <h3>群头像</h3>
        <van-image v-if="state.channelInfo" :src="state.imapi + '/api/v1/' + state.channelInfo?.logo + '?v=' + Date.now()"
          class="qtx"></van-image>
        <van-uploader :max-count="1" :after-read="afterRead">
          <van-button type="primary" color="#12CDB0">上传头像</van-button>
        </van-uploader>
      </div>
    </van-popup>
    <van-popup v-model:show="state.menameshow" round>
      <div class="qgg-box">
        <h3>群昵称</h3>
        <div class="qgg-sr">
          <van-field v-model="state.mename" rows="2" autosize type="textarea" maxlength="10" placeholder="请输入群昵称"
            show-word-limit />
        </div>
        <div class="btn" @click="onMeName">
          完成
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  reactive,
  onMounted,
  onUnmounted,
  watch
} from 'vue'
import {
  useRouter,
  useRoute
} from 'vue-router'
import {
  Toast
} from 'vant'
import {
  useStore
} from "vuex"
import WKSDK from "wukongimjssdk"
import {
  // ConnectStatus,
  ChannelTypeGroup,
  ChannelTypePerson,
  Channel,
} from "wukongimjssdk";
import {
  Dialog
} from 'vant';
import {
  exitChannel,
  deleteConversation,
  updateField,
  updateSettingGroups,
  updateSettingUsers,
  messageOffset,
  uploadGroupsAvatar,
  subscriberAttrUpdate,
} from '@/api/im.js'
import {
  GroupRole
} from "@/services/const.js";
import { getConversations } from '@/utils/imtools'
import { getQueryString } from '../../../utils/location'

export default {
  name: 'conversationpopup',
  props: ['subscribers', 'channelInfo'],
  setup(props) {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const state = reactive({
      show: false,
      imapi: process.env.VUE_APP_BASE_IM_API,
      uid: store.state.imuid,
      // 频道id
      channelID: "",
      // 频道类型
      channelType: ChannelTypeGroup,
      // 频道信息
      channelInfo: null,
      // 订阅者
      subscribers: null,
      // 当前订阅者信息
      subscriberOfMe: null,
      // 当前订阅者是否是管理员
      isManagerOrCreatorOfMe: false,
      // 群公告
      ggshow: false,
      message: '',
      // 群名称
      qnameshow: false,
      channelname: '',
      // 免打扰
      checkedMdr: false,
      // 指定
      checkedZd: false,
      // 群头像
      qtxshow: false,
      // 群昵称
      menameshow: false,
      mename: '',
    })
    // 监听subscribers,channelInfo变化
    watch(
      [() => props.subscribers, () => props.channelInfo],
      ([newSubscribers, newChannelInfo]) => {
        state.subscribers = newSubscribers
        // 获取当前订阅者信息
        if (state.subscribers && state.subscribers.length > 0) {
          for (const subscriber of state.subscribers) {
            if (subscriber.uid === state.uid) {
              state.subscriberOfMe = subscriber
              state.mename = state.subscriberOfMe.remark || state.subscriberOfMe.nickname
              // 是否是管理员
              if (state.subscriberOfMe?.role === GroupRole.manager || state.subscriberOfMe?.role === GroupRole
                .owner) {
                state.isManagerOrCreatorOfMe = true
              } else {
                state.isManagerOrCreatorOfMe = false
              }
            }
          }
        }
        // 获取频道信息
        state.channelInfo = newChannelInfo
        state.message = state.channelInfo?.orgData?.notice
        state.channelname = state.channelInfo?.title
        state.checkedMdr = state.channelInfo?.mute
        state.checkedZd = state.channelInfo?.top
      }, {
      deep: true,
      immediate: true
    } // 配置项
    );
    const onOpen = () => {
      state.show = true
    }
    const onClose = () => {
      state.show = false
    }
    // 获取头像
    const getAvatar = (fromUID) => {
      return `${process.env.VUE_APP_BASE_IM_API}/api/v1/users/${fromUID}/avatar?v=`
    }
    onMounted(() => {
      state.channelID = getQueryString("groupId")
      // // 获取订阅者
      // state.subscribers = WKSDK.shared().channelManager.getSubscribes(new Channel(state.channelID, state
      //   .channelType))
      //   console.log(state.subscribers)
      // WKSDK.shared().channelManager.addSubscriberChangeListener((channel) => {
      //   if (!new Channel(state.channelID, state.channelType).isEqual(channel)) {
      //     return
      //   }
      //   state.subscribers = WKSDK.shared().channelManager.getSubscribes(new Channel(state.channelID, state
      //     .channelType))
      // })
      // // 获取频道信息
      // state.channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(state.channelID, state
      //   .channelType))
      // if (!state.channelInfo) {
      //   WKSDK.shared().channelManager.fetchChannelInfo(new Channel(state.channelID, state
      //     .channelType))
      // }

    })

    onUnmounted(() => {

    })

    // 返回
    const onClickLeft = () => {
      router.back()
    }
    // 退出频道
    const onOut = () => {
      Dialog.confirm({
        title: '删除并退出',
        message: '退出后不会通知群里其他成员，且不会再接收此群聊消息',
      }).then(() => {
        exitChannel({
          channelID: state.channelID,
          channelType: state.channelType,
        }).then(() => {
          console.log('退出')
        }).catch((err) => {
          Toast(err.msg)
        })
        deleteConversation({
          channelID: state.channelID,
          channelType: state.channelType,
        }).then(() => {
          console.log('删除')
          getConversations()
          router.back()
        }).catch((err) => {
          Toast(err.msg)
        })
      }).catch(() => {
        // on cancel
      });
    }
    // 打开公告
    const openGg = () => {
      if (state.isManagerOrCreatorOfMe) {
        state.ggshow = true
      }
      // else {
      //   Toast('只有管理者才能修改群公告')
      // }
    }
    // 修改公告
    const onGg = () => {
      updateField(new Channel(state.channelID, state.channelType), {
        notice: state.message,
      }).then((res) => {
        if (res.status == 200) {
          Toast('群公告修改成功')
          state.channelInfo.orgData.notice = state.message
          state.ggshow = false
        }
      }).catch((err) => {
        Toast(err.msg)
      })
    }
    // 打开群名称
    const openQname = () => {
      if (state.isManagerOrCreatorOfMe) {
        state.qnameshow = true
      }
      // else {
      //   Toast('只有管理者才能修改群名称')
      // }
    }
    // 修改群名称
    const onQname = () => {
      updateField(new Channel(state.channelID, state.channelType), {
        name: state.channelname,
      }).then((res) => {
        if (res.status == 200) {
          Toast('群名称修改成功')
          state.channelInfo.title = state.channelname
          state.qnameshow = false
        }
      }).catch((err) => {
        Toast(err.msg)
      })
    }
    // 频道设置修改
    const channelSetting = (type, data) => {
      if (state.channelType === ChannelTypeGroup) {
        updateSettingGroups(new Channel(state.channelID, state.channelType), data).then((res) => {
          if (res.status == 200) {
            if (type == 'mdr') {
              Toast('免打扰修改成功')
              state.channelInfo.mute = state.checkedMdr
            } else {
              Toast('置顶修改成功')
              state.channelInfo.top = state.checkedZd
            }
          }
        }).catch((err) => {
          Toast(err.msg)
        })
      } else {
        updateSettingUsers(new Channel(state.channelID, state.channelType), data).then((res) => {
          if (res.status == 200) {
            if (type == 'mdr') {
              Toast('免打扰修改成功')
              state.channelInfo.mute = state.checkedMdr
            } else {
              Toast('置顶修改成功')
              state.channelInfo.top = state.checkedZd
            }
          }
        }).catch((err) => {
          Toast(err.msg)
        })
      }
    }
    // 修改免打扰
    const onChangeMdr = () => {
      let data = {
        mute: state.checkedMdr ? 1 : 0,
      }
      channelSetting('mdr', data)
    }
    // 修改置顶
    const onChangeZd = () => {
      let data = {
        top: state.checkedZd ? 1 : 0,
      }
      channelSetting('zd', data)
    }
    // 清理聊天记录
    const onClear = () => {
      Dialog.confirm({
        title: '清空聊天记录',
        message: '是否清空此会话的所有消息',
      }).then(() => {
        const conversation = WKSDK.shared().conversationManager.findConversation(new Channel(state.channelID,
          state.channelType))
        if (!conversation) {
          return;
        }
        messageOffset({
          channel_id: conversation.channel.channelID,
          channel_type: conversation.channel.channelType,
          message_seq: conversation.lastMessage?.messageSeq || 0,
        })
      }).catch(() => {
        // on cancel
      });
    }

    // 打开群头像
    const openQtx = () => {
      state.qtxshow = true
    }

    const afterRead = (params) => {


      let isImage = false

      let file = params.file
      let imageType = file.type
      if (imageType != 'image/jpeg' && imageType != 'image/jpg' && imageType != 'image/png') {
        isImage = false
      } else {
        isImage = true
      }
      let isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        Toast('上传头像图片只能是 JPG/PNG/JPEG 格式!');
        return
      }
      if (!isLt2M) {
        Toast('图片最大不能超过2M');
        return
      }
      let formData = new FormData()
      formData.append('file', file)
      uploadGroupsAvatar(new Channel(state.channelID, state.channelType), formData).then(res => {
        if (res.status == 200) {
          Toast('修改成功');
        }
      }).catch((err) => {
        Toast(err.msg)
      })
    }

    // 打开群昵称
    const openMeName = () => {
      state.menameshow = true
    }
    // 修改群昵称
    const onMeName = () => {
      subscriberAttrUpdate(new Channel(state.channelID, state.channelType), store.state.imuid || "", {
        remark: state.mename,
      }).then(res => {
        if (res.status == 200) {
          Toast('修改成功');
          state.subscriberOfMe.remark = state.mename
          state.menameshow = false
        }
      }).catch((err) => {
        Toast(err.msg)
      })
    }

    const onMore = () => {
      state.moreshow = true
    }

    return {
      state,
      onClickLeft,
      onOpen,
      onClose,
      getAvatar,
      onOut,
      onGg,
      openGg,
      onChangeMdr,
      onChangeZd,
      onClear,
      openQname,
      onQname,
      openQtx,
      afterRead,
      openMeName,
      onMeName,
      onMore
    }
  }
}
</script>

<style scoped>

.user-box {
  display: flex;
  align-items: center;
  padding: 10px 20px;
}

.user-box .user-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
    flex-shrink: 0;
}
.user-box p {
  font-size: 28px;
  color: #666;
  margin-left: 20px;
}

.more {
  width: 100%;
  text-align: center;
  font-size: 24px;
  color: #E56E50;
  padding-top: 8px;
  padding-bottom: 3px;
}

.conversationpopup-box {
  background-color: #f6f6f6;
  height: 100%;
  padding: 30px 0;
}

.conversationpopup-box .title {
  font-size: 36px;
  text-align: center;
  color: #333;
}

.conversationpopup-box .user-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 30px;
  padding: 0 20px;
}

.conversationpopup-box .user-list .item {
  width: 20%;
  text-align: center;
  margin-bottom: 20px;
}

.conversationpopup-box .user-list .item .user-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
    flex-shrink: 0;
}

.conversationpopup-box .user-list .item p {
  font-size: 26px;
  color: #666;
  margin-top: 20px;
}

.conversationpopup-box .gn-box {
  margin-top: 20px;
}

.conversationpopup-box .gn-box .gn-item {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 30px;
  padding: 30px;
}

.conversationpopup-box .gn-box .gn-item.gg {
  display: block;
}

.conversationpopup-box .gn-box .gn-item.gg .r {
  margin-top: 10px;
}

.conversationpopup-box .gn-box .gn-item .l {
  font-size: 30px;
  color: #333;
}

.conversationpopup-box .gn-box .gn-item .r {
  display: flex;
  align-items: center;
}

.conversationpopup-box .gn-box .gn-item .r p {
  color: #999;
  font-size: 28px;
}

.conversationpopup-box .gn-box .gn-item .r img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.conversationpopup-box .gn-box .gn-item.out {
  justify-content: center;
  color: red;
}

.qgg-box {
  padding: 30px 0;
  width: 500px;
}

.qgg-box h3 {
  font-size: 30px;
  text-align: center;
  margin-bottom: 20px;
}

.qgg-box .btn {
  width: 450px;
  background-color: #12CDB0;
  color: #fff;
  font-size: 28px;
  margin: 30px auto 0;
  text-align: center;
  padding: 20px 0;
  border-radius: 100px;
}

.qtx-box {
  text-align: center;
}

.qtx {
  width: 200px;
  height: 200px;
  display: block;
  margin: 30px auto;
}
</style>